// ============================================================================
// Express tag — the one priority marker shown wherever an express order surfaces
// (order list, operations board, pending tasks). Mirrors the pending-queue panel's
// look so "express" reads the same across every OMS screen.
// ============================================================================
import { ThunderboltFilled } from "@ant-design/icons";
import { Tag } from "antd";
import React from "react";

const ExpressTag: React.FC<{ show?: boolean }> = ({ show }) =>
  show ? (
    <Tag color="red" icon={<ThunderboltFilled />} style={{ marginInlineEnd: 0 }}>
      express
    </Tag>
  ) : null;

export default ExpressTag;
